import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import PhoneInput from 'react-phone-number-input';
import { BASEAPIURL, BASEURL, uploadFileAPI, UPLOADNODEURLCDN } from '../../../../config';

function StudentProfileUpdate({ forpage }) {
    const navigate = useNavigate();
    const [defaultProfilePicture] = useState('placeholders/userProfileImg.png');
    const [Profile, setProfile] = useState({
        name: '',
        email: '',
        city: '',
        mobile: '',
        oldMobile: '',
        lastLogin: '',
        mobileOTP: '',
        mobileVerify: 0,
        photo: defaultProfilePicture,
        usertype: localStorage.getItem('usertype'),
    });
    const UpdateProfile = (name, value) => {
        setProfile({ ...Profile, [name]: value });
    };
    const [MsgClass, setMsgClass] = useState('alert-danger');
    const [APIMessage, setMessage] = useState();
    const [IsAPIAction, setIsAPIAction] = useState(false);

    const [ShowCVfile, setShowCVfile] = useState('Upload Profile Picture');
    const [PhoneNumber, setPhoneNumber] = useState('');
    function onChangePhoneNumber() {
        // noting to be dne
    }
    const [MobileAready, setMobileAready] = useState('');
    const [EmailAready, setEmailAready] = useState('');

    // for file uploade will be here
    async function uploadFile(file, fileName) {
        setIsAPIAction(true);
        setShowCVfile(fileName);
        try {
            const data = await uploadFileAPI(file, 'stdProfileImg');
            setIsAPIAction(false);
            if (data && data.file && data.file !== 0) {
                UpdateProfile('photo', data.file);
            } else {
                alert(data.message);
            }
        } catch (ex) {
            alert(ex.message);
            setCategory({ ...Category, apiCall: false});
        }
    }
    // for file uploade will be here

    const UploadInstrProfiePics = () => {
        document.getElementById('instr_profie_pics').click();
    };
    // for file uploade will be here
    // async function checkEmailAready(emailid) {
    //     let returntype = false;
    //     setEmailAready('');
    //     setMsgClass('alert-danger');
    //     try {
    //         const url = `${BASEAPIURL}/student/checkifalreadyemail`;
    //         const formData = new FormData();
    //         formData.append('emailid', emailid);
    //         const config = {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 Authorization: `Basic ${localStorage.getItem('loggedToken')}`,
    //             },
    //         };
    //         axios.post(url, formData, config).then((response) => {
    //             if (response.data.status === 1) {
    //                 setEmailAready(response.data.message.toString());
    //                 returntype = true;
    //                 setIsAPIAction(true);
    //             } else {
    //                 setEmailAready('');
    //             }
    //         });
    //     } catch (err) {
    //         console.log(err);
    //         setEmailAready('Something went wrong, Please try again later.');
    //     }
    //     return returntype;
    // }

    async function checkMobileAready(mobileno) {
        setEmailAready('');
        let returntype = false;
        try {
            const url = `${BASEAPIURL}/student/checkifalreadymobile`;
            const formData = new FormData();
            formData.append('mobileno', mobileno);
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Basic ${localStorage.getItem('loggedToken')}`,
                },
            };
            axios.post(url, formData, config).then((response) => {
                if (response.data.status === 1) {
                    setMobileAready(response.data.message.toString());
                    setIsAPIAction(true);
                    setProfile({ ...Profile, sendOTP: false, sentOTP: false });
                    returntype = true;
                } else {
                    const cleanValue1 = mobileno.replace(/\s+/g, ''); // removes all spaces
                    const cleanValue2 = Profile.oldMobile.replace(/\s+/g, '');
                    if (cleanValue1 !== cleanValue2) {
                        setProfile({ ...Profile, sendOTP: true, sentOTP: false });
                        setMobileAready('');
                        // setMobileAready(`${mobileno} ${Profile.oldMobile}`);
                        setIsAPIAction(true);
                    } else {
                        setMobileAready('');
                        setProfile({ ...Profile, sendOTP: false, sentOTP: false });
                    }
                    returntype = false;
                }
            });
        } catch (err) {
            console.log(err);
            setProfile({ ...Profile, sendOTP: true, sentOTP: false });
            setMobileAready('Something went wrong, Please try again later.');
        }
        return returntype;
    }

    async function UpdateStudentProfile() {
        try {
            setMsgClass('alert-danger');
            setIsAPIAction(true);
            const url = `${BASEAPIURL}/student/UpdateStudentProfile`;
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Basic ${localStorage.getItem('loggedToken')}`,
                },
            };
            Profile.usertype = localStorage.getItem('usertype');
            axios
                .post(url, Profile, config)
                .then((response) => {
                    setIsAPIAction(false);
                    if (response.data.status === 1) {
                        setMsgClass('alert-success');
                        setTimeout(() => {
                            setMessage('');
                            navigate('/user/page/profilesetting');
                        }, 2786);
                    }
                    setMessage(response.data.message);
                })
                .catch((er) => {
                    setIsAPIAction(false);
                    console.log(er);
                    setMessage('Something went wrong, Please try again later.');
                });
        } catch (err) {
            setIsAPIAction(false);
            setMsgClass('alert-danger');
            setTimeout(() => {
                setMessage('');
            }, 2786);
            console.log(err);
            setMessage('Something went wrong, Please try again later.');
        }
    }

    // for the mobile Verification API
    async function sentOtpMessage(mobileno) {
        setMsgClass('alert-danger');
        if (mobileno) {
            // all goood to go
        } else {
            setMobileAready('Sending SMS');
            return false;
        }
        setMobileAready('Sending SMS');
        setProfile({ ...Profile, sendOTP: false, sentOTP: true });
        const cleanMobileNo = mobileno.replace(/\s+/g, ''); // removes all spaces
        let returntype = false;
        try {
            const url = `${BASEAPIURL}/student/sentOtpMessage`;
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Basic ${localStorage.getItem('loggedToken')}`,
                },
            };
            axios.post(url, { mobile: cleanMobileNo }, config).then((response) => {
                setProfile({
                    ...Profile,
                    sendOTP: false,
                    sentOTP: response.data.status===1,
                    otp_id: response.data.data && response.data.data.otp_id ? response.data.data.otp_id : 0
                });
                setMobileAready(response.data.status ? '' : response.data.message);
                setMsgClass(response.data.status ? 'alert-success' : 'alert-danger');
            });
        } catch (err) {
            console.log(err);
            setMobileAready('Something went wrong, Please try again later.');
        }
        return returntype;
    }

    async function verifyOtpMessage(mobileno, otp_id) {
        setMsgClass('alert-danger');
        if (mobileno) {
            // all goood to go
        } else {
            setMobileAready('Confirmaing OTP');
            return false;
        }
        setMobileAready('Sending SMS');
        setProfile({ ...Profile, sendOTP: false, sentOTP: true, confirmingOTP: true });
        const cleanMobileNo = mobileno.replace(/\s+/g, ''); // removes all spaces
        let returntype = false;
        try {
            const url = `${BASEAPIURL}/student/verifyOtpMessage`;
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Basic ${localStorage.getItem('loggedToken')}`,
                },
            };
            axios.post(url, {
                mobile: cleanMobileNo,
                otp_id,
                otp: Profile.mobileOTP
            }, config).then((response) => {
                setProfile({
                    ...Profile,
                    sendOTP: false,
                    sentOTP: response.data.status===1 ? false : true,
                    confirmingOTP: response.data.status===1
                });
                setMobileAready(response.data.status ? 'Your Mobile Number has been verified.' : response.data.message);
                setMsgClass(response.data.status ? 'alert-success' : 'alert-danger');
            });
        } catch (err) {
            console.log(err);
            setMobileAready('Something went wrong, Please try again later.');
        }
        return returntype;
    }
    // for the mobile Verification API

    useEffect(() => {
        const FetchProfile = async () => {
            try {
                const res = await fetch(`${BASEAPIURL}/student/myprofile`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Basic ${localStorage.getItem('loggedToken')}`,
                    },
                    body: JSON.stringify({
                        loggedToken: localStorage.getItem('loggedToken'),
                        usertype: localStorage.getItem('usertype'),
                    }),
                });
                const resJson = await res.json();
                if (res.status === 200) {
                    if (resJson.userdata.mobileVerify && resJson.userdata.mobileVerify !== '0') {
                        // the mobile is already verified
                        setProfile(resJson.userdata ? resJson.userdata : {});
                        // the mobile is already verified 
                    } else {
                        setProfile({ ...resJson.userdata ? resJson.userdata : {}, sendOTP: true });
                    }
                    setPhoneNumber(
                        resJson.userdata && resJson.userdata.mobile ? resJson.userdata.mobile : ''
                    );
                } else {
                    console.log(resJson.message);
                }
            } catch (err) {
                console.log(err);
            }
        };
        FetchProfile();
    }, []);

    function GetShowData(forData, Index, defaultValue) {
        let returnValue = defaultValue;
        if (forData && forData[Index] && forData[Index] !== null && forData[Index] !== '') {
            returnValue = forData[Index];
        }
        return returnValue;
    }

    return (
        <>
            <div className="pb-3" forpage={forpage}>
                <div className="row">
                    <div className="col-md-7">
                        <div className="ry_instr_shadow p-3">
                            <h5 className="mb-3 text-center">Profile Details</h5>
                            <form
                                id="Inst-Regi-Form"
                                encType="multipart/form-data"
                                className="p-1"
                                style={{ display: 'block' }}
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    if (!IsAPIAction && EmailAready === '' && MobileAready === '') {
                                        UpdateStudentProfile();
                                    }
                                }}
                            >
                                <div className="form-group mb-1">
                                    <label className="ry_label">Your Name</label>
                                    <input
                                        type="text"
                                        name="name"
                                        readOnly
                                        value={GetShowData(Profile, 'name', '')}
                                        onClick={() => {
                                            // UpdateProfile('name', e.target.value);
                                            alert("You cannot update the name. Please contact the administrator for assistance.");
                                        }}
                                        className="form-control"
                                        placeholder="Enter Your Name"
                                    />
                                </div>

                                <div className="form-group mb-1" style={{ position: 'relative' }}>
                                    <label className="ry_label">Phone Number</label>
                                    <PhoneInput
                                        international
                                        className="form-control"
                                        name="phonenumber"
                                        value={PhoneNumber}
                                        readOnly={Profile.mobileVerify && Profile.mobileVerify !== '0'}
                                        onChange={onChangePhoneNumber}
                                        onClick={(e) => {
                                            if (Profile.mobileVerify && Profile.mobileVerify !== '0') {
                                                alert("You cannot update the Verified Mobile. Please contact the administrator for assistance.");
                                            }
                                        }}
                                        onKeyUpCapture={(e) => {
                                            if (Profile.mobileVerify && Profile.mobileVerify !== '0') {
                                                alert("You cannot update the Mobile. Please contact the administrator for assistance.");
                                            } else {
                                                setPhoneNumber(e.target.value);
                                                setIsAPIAction(false);
                                                UpdateProfile('mobile', e.target.value);
                                                checkMobileAready(e.target.value);
                                            }
                                        }}
                                        defaultCountry="IN"
                                        style={{ position: 'relative' }}
                                    />
                                    {Profile.sendOTP && (
                                        <div
                                            onClick={() => {
                                                sentOtpMessage(PhoneNumber);
                                            }}
                                            style={{
                                                position: 'absolute',
                                                right: '10px',
                                                zIndex: 999999,
                                                top: '30px',
                                                color: '#cc0000',
                                            }}
                                        >
                                            Send OTP
                                        </div>
                                    )}
                                    {Profile.sentOTP && (
                                        <div className="form-group mt-2 mb-1">
                                            <label className="ry_label">
                                                Enter OTP received on <b className='text-info'>{PhoneNumber}</b>
                                            </label>
                                            <input
                                                type="number"
                                                min={0}
                                                name="mobileOTP"
                                                value={GetShowData(Profile, 'mobileOTP', '')}
                                                onChange={(e) => {
                                                    UpdateProfile('mobileOTP', e.target.value);
                                                }}
                                                className="form-control"
                                                placeholder="Enter OTP here"
                                            />
                                            <div className="text-center">
                                                <button
                                                    type="button"
                                                    className="btn mt-2 btn-docsta-instructor"
                                                    onClick={() => {
                                                        verifyOtpMessage(PhoneNumber, Profile.otp_id);
                                                    }}
                                                >
                                                    Confirm OTP
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                    <div
                                        className={`message alert hide_empty_div mt-2 mb-3 ${MsgClass}`}
                                    >
                                        {MobileAready ? <span>{MobileAready}</span> : ''}
                                    </div>
                                </div>

                                <div className="form-group mb-1">
                                    <label className="ry_label">Email ID</label>
                                    <input
                                        type="email"
                                        name="emailid"
                                        className="form-control"
                                        placeholder="Enter Email ID"
                                        readOnly
                                        value={GetShowData(Profile, 'email', '')}
                                        onClick={() => {
                                            // UpdateProfile('name', e.target.value);
                                            alert("You cannot update the Email. Please contact the administrator for assistance.");
                                        }}
                                        // onChange={(e) => {
                                        //     setIsAPIAction(false);
                                        //     UpdateProfile('email', e.target.value);
                                        //     checkEmailAready(e.target.value);
                                        // }}
                                    />
                                    <div
                                        className={`message alert hide_empty_div mb-3 ${MsgClass}`}
                                    >
                                        {EmailAready ? <span>{EmailAready}</span> : ''}
                                    </div>
                                </div>

                                <div className="form-group mb-1">
                                    <label className="ry_label">Gender</label>
                                    <br />
                                    <input
                                        type="radio"
                                        name="name"
                                        checked={
                                            // eslint-disable-next-line no-unneeded-ternary
                                            GetShowData(Profile, 'gender', '') === 'Male'
                                                ? true
                                                : false
                                            // eslint-enable-next-line no-unneeded-ternary
                                        }
                                        onChange={() => {
                                            UpdateProfile('gender', 'Male');
                                        }}
                                    />
                                    &nbsp;Male &nbsp; &nbsp;
                                    <input
                                        type="radio"
                                        name="name"
                                        checked={
                                            // eslint-disable-next-line no-unneeded-ternary
                                            GetShowData(Profile, 'gender', '') === 'Female'
                                                ? true
                                                : false
                                            // eslint-enable-next-line no-unneeded-ternary
                                        }
                                        onChange={() => {
                                            UpdateProfile('gender', 'Female');
                                        }}
                                    />
                                    &nbsp;Female
                                </div>

                                <div className="form-group mb-1">
                                    <label className="ry_label">Address</label>
                                    <textarea
                                        name="name"
                                        value={GetShowData(Profile, 'address', '')}
                                        onChange={(e) => {
                                            UpdateProfile('address', e.target.value);
                                        }}
                                        className="form-control"
                                        placeholder="Enter your address"
                                    ></textarea>
                                </div>

                                <div className="form-group mb-1">
                                    <label className="ry_label">City</label>
                                    <input
                                        type="text"
                                        name="city"
                                        value={GetShowData(Profile, 'city', '')}
                                        onChange={(e) => {
                                            UpdateProfile('city', e.target.value);
                                        }}
                                        className="form-control"
                                        placeholder="Enter your city"
                                    />
                                </div>

                                <div
                                    className="text-right"
                                    style={{ cursor: 'pointer' }}
                                    onClick={UploadInstrProfiePics}
                                >
                                    <input
                                        type="file"
                                        name="photo"
                                        accept="image/*"
                                        className="d-none"
                                        id="instr_profie_pics"
                                        onChange={(e) => {
                                            if (e.target.files.length > 0) {
                                                uploadFile(
                                                    e.target.files[0],
                                                    e.target.files[0].name
                                                );
                                            }
                                        }}
                                    />
                                    {ShowCVfile} &nbsp;
                                    <i className="fa fa-upload"></i>
                                </div>
                                <div className={`message alert hide_empty_div mb-3 ${MsgClass}`}>
                                    {APIMessage ? <span>{APIMessage}</span> : ''}
                                </div>
                                <div className={`mt-3 text-center ${IsAPIAction ? '' : 'd-none'}`}>
                                    <img
                                        style={{ maxWidth: '32px' }}
                                        src={`${BASEURL}loader.gif`}
                                        alt=""
                                    />
                                </div>
                                <div className={`row mt-3 ${IsAPIAction ? 'd-none' : ''}`}>
                                    <div className="col-md-6">
                                        <Link
                                            to="/user/page/profilesetting"
                                            className="btn d-block btn-outline-danger"
                                        >
                                            Cancel
                                        </Link>
                                    </div>
                                    <div className="col-md-6">
                                        <button type="submit" className="btn btn-docsta-instructor">
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="col-md-5">
                        <div className="text-center ry_instr_shadow p-3">
                            <img
                                src={`${UPLOADNODEURLCDN}${GetShowData(
                                    Profile,
                                    'photo',
                                    defaultProfilePicture
                                )}`}
                                alt={GetShowData(Profile, 'name', 'NA')}
                                className="p-3"
                                onClick={UploadInstrProfiePics}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default StudentProfileUpdate;
